interface _Project {
    id: string | undefined,
    title: string | undefined,
    subtitle: string | undefined,
    brief: string | undefined,
    description: string | undefined,
    industry: string | undefined,
    technologies: string | undefined,
    isVisible?: boolean,
}

export class Project implements _Project {
    constructor(
        public id: string | undefined,
        public title: string | undefined,
        public subtitle: string | undefined,
        public brief: string | undefined,
        public description: string | undefined,
        public industry: string | undefined,
        public technologies: string | undefined,
        public isVisible?: boolean | undefined,
    ) {
    }
}


export const projectList: Project[] = [
    {
        id: "projects-soh",
        title: "State of Ohio - JFS",
        industry: "Government",
        subtitle: "Kony Mobile Apps for the State of Ohio Agencies.  Jobs and Family Services " +
            "mobile Apps used by citizens in need of family assistance (SNAP, re-employment services, etc.).",
        brief: "Mobile Apps for the State of Ohio Agencies",
        description: "OCR, Azure Chat, Responsive Web Design (RWD), Metrics, Analytic and Reports",
        technologies: "Temenos (Kony) Quantum",
    },
    {
        id: "projects-beacons",
        title: "Disney World, Imaginarium",
        industry: "Entertainment",
        subtitle: "RMS signal smoothing used in detection from beacon signals of parade characters in the " + 
        "proximity of the guests.  Combined with ecommerce to make purchases related to the favorite" +
        "characters for children and their parents.",
        brief: "RMS signal smoothing used in detection from beacon signals of parade characters",
        description: "Beacons",
        technologies: "IOS Swift",
    },
    {
        id: "projects-gm",
        title: "General Motors",
        industry: "Automotive",
        subtitle: "Service inspection iPad App that replaces the paper and clipboard to inspect" + 
        "incoming GM car owners for regular service and maintenance. Create custom keyboard for fast " +
        "VIN key entry.  Legacy API to SOAP/XML services presented to the owner's car service history," +
        "safety recall notices and recommendations of wear maintence for tire, windshield wipers, etc.",
        brief: "Service inspection iPad App",
        description: "SOAP/XML, RESTful/JSON",
        technologies: "IOS XCode - iPad",
        isVisible: false,
    },
    {
        id: "projects-dineequity",
        title: "Dine Equity",
        industry: "Restaurant",
        subtitle: "Applebee's and IHOP QSR mobile App.",
        brief: "Applebee's and IHOP QSR mobile App",
        description: "Includes location search, menu presentation, online ordering, Gift Cards, Social Media",
        technologies: "Kony for Android and IOS",
        isVisible: false,
    },
    {
        id: "projects-whataburger",
        title: "Whataburger",
        industry: "Restaurant",
        subtitle: "Mobile Strategy, Gap Analysis, Location Based Aervices",
        brief: "Mobile Strategy, Gap Analysis, Location Based Aervices",
        description: "Analytics, Beacons, GPS and WiFi",
        technologies: "Xamarin",
        isVisible: false,
    },
    {
        id: "projects-amgen",
        title: "Amgen",
        industry: "Healthcare",
        subtitle: "Medical Trials Assistant Platform",
        brief: "Medical Trials Assistant Platform",
        description: "Bluetooth, Temperature excursion sensors",
        technologies: "Tablets, Document Management Systems",
        isVisible: false,
    },
    {
        id: "projects-lorillard",
        title: "Lorillard",
        industry: "Consumer Goods",
        subtitle: "Remote on-site contract signature capture.",
        brief: "Remote on-site contract signature capture.",
        description: "jQueryMobile",
        technologies: "Sharepoint, Android and IOS",
        isVisible: false,
    },
    {
        id: "projects-bgcoa",
        title: "Boys and Girls Clubs of America",
        industry: "Social Services",
        subtitle: "Mobile Strategy",
        brief: "Mobile Strategy",
        description: "User Experience",
        technologies: "Android and IOS",
        isVisible: false,
    },
    {
        id: "projects-hersheys",
        title: "Hershey's",
        industry: "Consumer Goods",
        subtitle: "Inventory management and Sales promotion",
        brief: "Sales Productivity iPad App for inventory management at the retail locations.  In additon to taking photos of shelves, also managed the travel route between location for added simplicity.",
        description: "IOS CoreData, Offline/Online Sync",
        technologies: "IOS Xcode, Salesforce, CoreData",
        isVisible: true,
    },
    {
        id: "projects-aaahq",
        title: "AAA National HQ",
        industry: "Automotive",
        subtitle: "Digital-Mobile Architecture Stratgy, Fleet Management, LBS-based Scheduling and Dispatch",
        brief: "New architecuture stratgy integrating enterprise and franchise systems to mobile apps for fleet management, scheduling and dispatch.  Incorporating location-based services (LBS) to optimize dispatch and routing of AAA roadside assistance vehicles.",
        description: "M-tier Digital Integration",
        technologies: "HQ and Franchise Communications, Quintel, Modeling",
        isVisible: true,
    },
    {
        id: "projects-sprint",
        title: "Sprint",
        industry: "Communications",
        subtitle: "Retail associate's guided-sales tablet with gamification.",
        brief: "iPad App for retail associate's guided-sales of mobile devices, their suscription plans and accessories.  The app also includes gamification to incent the retail associates to use the app and increase sales of mobile devices and plans.",
        description: "Bluetooth, OCR, Signature capture, POS terminal, Gamification",
        technologies: "AngularJS, IOS XCode",
    },
    {
        id: "projects-garmin",
        title: "Garmin",
        industry: "Consumer Goods",
        subtitle: "Garmin Phone -- a GPS-centric mobile phone",
        brief: "Garmin Phone -- a GPS-centric mobile phone",
        description: "Garmin developed hardware",
        technologies: "Qt4, Android (Dalvik) OS",
        isVisible: false,
    },
    {
        id: "projects-rim",
        title: "Research in Motion",
        industry: "Consumer Goods",
        subtitle: "Mobile Voice Server",
        brief: "MVS was a platform for enterprise Blackberry users to route their phone calls through the corporate PBX to leverage PBX features by extending the PBX capabilities to Blackberry device.",
        description: "SIP, Intel Telephony hardware",
        technologies: "Enterprise, Blackberry & BES",
        isVisible: true,
    },
];
